import { render } from "./link-expired.vue?vue&type=template&id=07dcd971"
import script from "./link-expired.js?vue&type=script&lang=js&external"
export * from "./link-expired.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__